<template>
  <div id="cancel-reason-modal">
    <el-dialog
      custom-class="cancel-reason-dialog"
      v-model="showModal"
      :close-on-click-modal="false"
      size="small"
      @close="modalClose"
      @open="modalOpen"
    >
      <!-- 头部 -->
      <div class="custom-header">
        请选择取消原因
        <span class="fc-r">*</span>
        <!-- 关闭 -->
        <div class="el-dialog__headerbtn" @click="modalClose">
          <i class="el-dialog__close el-icon el-icon-close"></i>
        </div>
      </div>
      <div class="custom-body">
        <el-radio-group v-model="checkedReasonId" @change="changeReason">
          <ul class="reason-list">
            <li class="reason-item" v-for="(reason, index) in reasonRadios" :key="index">
              <el-radio :label="reason.id" class="reason-content">
                <div class="reason-item-text">{{reason.value}}</div>
                <div class="reason-item-tips" v-if="checkedReasonId === 0 && index === 0 && !order.ota_info && !order.enable_api">
                  上上签目前已支持复制订单，商品选错无需重新<br/>
                  下单，<a @click="handleCopyOrder">点此复制</a>
                </div>
              </el-radio>
            </li>
          </ul>
        </el-radio-group>
        <el-input
          v-show="checkedReasonId === 3"
          v-model="otherReason"
          placeholder="请留下您的宝贵意见，帮助我们改进服务质量~"
          :rows="2"
          :maxlength="50"
          type="textarea"
        ></el-input>
      </div>

      <template slot="footer" class="dialog-footer">
        <el-button class="foot-btn" type="primary" :disabled="couldnotSubmit" @click="modalClose(1)">提交</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import Http from '@/libs/http';
import sensorsdata from 'sa-sdk-javascript';

export default {
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    // 是否打开
    value: {
      type: Boolean,
      required: true,
      default: false,
    },
    order: {
      type: Object,
      default: null,
    },
  },
  created() {},
  data() {
    return {
      showModal: this.value, // 是否展示
      reasonRadios: [
        {
          id: 0,
          value: '商品选错了，已重新下单',
        },
        {
          id: 1,
          value: '出行计划变更',
        },
        {
          id: 2,
          value: '选择在其他平台办理',
        },
        {
          id: 3,
          value: '其他原因',
        },
      ],
      checkedReasonId: undefined,
      otherReason: '',
    };
  },
  watch: {
    value(newVal) {
      this.showModal = newVal;
    },
    showModal(newVal) {
      this.$emit('input', newVal);
    },
  },
  computed: {
    couldnotSubmit() {
      return this.checkedReasonId === undefined;
    },
  },
  methods: {
    // 关闭弹窗
    modalClose(success) {
      if (success === 1) {
        let reason = '';
        if (this.checkedReasonId === 3) {
          reason = this.otherReason;
        } else {
          reason = this.reasonRadios[this.checkedReasonId].value;
        }
        Http.post('/order_cancel', {
          user_order_id: this.order.user_order_id,
          order_cancel_cause: reason,
        }).then(() => {
          this.$emit('cancelOrder', this.order);
          this.$emit('input', false);
          this.$nextTick(() => {
            this.checkedReasonId = undefined;
            this.otherReason = '';
          });
        }).catch((e) => {
          if (e) console.log(e);
        });
      } else {
        this.$emit('input', false);
        this.$nextTick(() => {
          this.checkedReasonId = undefined;
          this.otherReason = '';
        });
      }

    },
    // 打开弹窗
    modalOpen() {},
    // 选中原因
    changeReason(id) {
      this.checkedReasonId = id;
    },
    handleCopyOrder() {
      sensorsdata.track('ElementClick', {
        pagefrom: 'PC',
        click_content: '【取消列表】切换产品',
      });
      this.$router.push({
        name: 'EditProduct',
        query: {
          id: this.order.user_order_id,
        },
      });
    },
  },
};
</script>

<style lang="less">
@import "../../assets/less/variable";
#cancel-reason-modal {
  .cancel-reason-dialog {
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    width: 360px;
    .el-dialog__header {
      display: none;
    }

    .el-dialog__body {
      padding: 0;
      .custom-header {
        height: 50px;
        display: block;
        padding: 0 20px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        border-bottom: 1px solid #f0f0f0;
        font-size: 16px;
        color: #333333;
        .el-dialog__close {
          position: absolute;
          right: 20px;
          top: 16px;
          width: 19px;
          height: 19px;
          transform: rotateZ(45deg);
          cursor: pointer;

          &::before {
            content: "";
            display: block;
            width: 19px;
            position: absolute;
            top: 9px;
            left: 0;
            border-top: 1px solid #777;
          }

          &::after {
            content: "";
            display: block;
            height: 19px;
            position: absolute;
            top: 0;
            left: 9px;
            border-left: 1px solid #777;
          }

          &:hover {
            &::before,
            &::after {
              border-color: @main;
            }
          }
        }
      }
      .custom-body {
        padding: 20px 40px 0;
        .el-radio-group{
          width: 100%;
        }
        .reason-list {
          .reason-item {
            margin-bottom: 20px;
            .reason-content{
              display: flex;
              justify-content: flex-start;
              flex-wrap: wrap;
              gap: 12px;
              .el-radio__label{
                width: 80%;
                .reason-item-text{
                  margin-top: 2px;
                }
                .reason-item-tips{
                  width: 100%;
                  font-size: 12px;
                  color: #91999F;
                  line-height: 17px;
                  margin-top: 8px;
                  padding-right: 40px;
                  >a{
                    color: rgba(89, 159, 255, 1);
                    cursor: pointer;
                  }
                }
              }
             
            }
            
          }
        }
        .el-textarea__inner {
          margin-top: -10px;
          margin-bottom: 10px;
          height: 60px;
          font-size: 14px;
          border: 1px solid #CFCFCF;
          border-radius: 4px;
        }
      }
    }
    .el-dialog__footer {
      padding: 20px 40px 30px;
      .foot-btn {
        width: 100%;
      }
    }

  }
  .fc-r {
    color: #ff5a60!important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/order-list/cancel-reason.vue